export type UIDType = () => string;

// inspired by react-uid
export function uidSeed(prefix?: string): UIDType {
    let counter = 0;
    prefix = prefix ? prefix + '-' : '';
    function uid(): string {
        return `${prefix}${counter++}`;
    }
    return uid;
}
